const notification = {
  state: {
    notifications: []
  },
  getters: {
    notifications: state => state.notifications
  },
  mutations: {
    addNotification: (state, notification) => state.notifications.push(notification),
    removeNotificationById: (state, id) => (state.notifications = state.notifications.filter(x => x.id !== id)),
    removeNotificationByType: (state, type) => (state.notifications = state.notifications.filter(x => x.type !== type))
  }
}

export default notification
